export const ROUTES = {
  HOME: '/' as const,
  DASHBOARD: '/dashboard' as const,
  AUTH: {
    LOGIN: '/auth/login' as const,
    SIGNUP: '/auth/signup' as const,
    PROFILE: '/auth/profile' as const,
    SETTINGS: '/auth/settings' as const,
  },
  NOT_FOUND: '/404',
  ONBOARDING: '/onboarding',
  CATEGORIES: '/categories' as const,
  FOODS: '/foods' as const,
  PLACES: '/places' as const,
  REVIEWS: '/reviews' as const,
  USERS: '/users' as const,
  SETTINGS: '/settings' as const,
  FEED: '/' as const,
  NOTIFICATIONS: '/notifications' as const,
  NOTIFICATIONS_SETTINGS: '/notifications/settings' as const,
  LANGUAGE: '/language' as const,
} as const;
